import { domainAction } from './domain-redux';
import { ARBITRARY_ID_IS_ONLINE, DOMAIN_TYPE_ARBITRARY } from '../../consts';
/**
 * @param dispatch
 * @param uiState
 */
export var dispatchIsOnline = function (dispatch, value) {
    var _a, _b;
    dispatch(domainAction.mergeModelsPayload((_a = {},
        _a[DOMAIN_TYPE_ARBITRARY] = (_b = {},
            // not, only object type can be set as arbitrary state slice
            _b[ARBITRARY_ID_IS_ONLINE] = {
                status: value,
                changedAt: new Date().toISOString(),
            },
            _b),
        _a)));
};
